// extracted by mini-css-extract-plugin
module.exports = {"root":"CancelPendingInvoice_root__2fpuJ"};